import { PROJECT_URL_PATH_SEGMENT } from '@neptune/shared/core-project-domain';
import { AppRoute } from '@neptune/shared/routing-domain';

import { COMPARE_QUERY_PARAMS, FILTERING_QUERY_PARAMS } from 'router/config';

const getTabFromSplit = (split?: 'cmp' | 'tbl' | 'bth') => {
  switch (split) {
    case 'cmp': {
      return 'compare';
    }

    case 'bth': {
      return 'compare';
    }

    case 'tbl': {
      return 'table';
    }

    default: {
      return 'table';
    }
  }
};

const runDetailsNoTabRoute: AppRoute = {
  name: 'project-compatible-run-details-no-tab',
  path: `/:organizationName/${PROJECT_URL_PATH_SEGMENT}/e/:shortId`,
  canActivate:
    () =>
    ({ params }) => {
      return Promise.reject({
        redirect: {
          name: 'project.entity-with-shortid-only',
          params: {
            ...params,
            tab: 'details',
          },
        },
      });
    },
};

const enterpriseRunDetailsNoTabRoute: AppRoute = {
  name: 'enterprise-context/project-compatible-run-details-no-tab',
  path: `~/o/:organizationName/org/${PROJECT_URL_PATH_SEGMENT}/e/:shortId`,
  canActivate:
    () =>
    ({ params }) => {
      return Promise.reject({
        redirect: {
          name: 'enterprise-context/project.entity-with-shortid-only',
          params: {
            ...params,
            tab: 'details',
          },
        },
      });
    },
};

const runDetailsRoute: AppRoute = {
  name: 'project-run-compatible-details',
  path: `/:organizationName/${PROJECT_URL_PATH_SEGMENT}/e/:shortId/:detailsTab`,
  canActivate:
    () =>
    ({ params }) => {
      return Promise.reject({
        redirect: {
          name: 'project.entity-with-shortid-only',
          params: {
            ...params,
            tab: 'details',
            detailsTab: params.detailsTab === 'all' ? 'attributes' : params.detailsTab,
          },
        },
      });
    },
};

const enterpriseRunDetailsRoute: AppRoute = {
  name: 'enterprise-context/project-run-compatible-details',
  path: `~/o/:organizationName/org/${PROJECT_URL_PATH_SEGMENT}/e/:shortId/:detailsTab`,
  canActivate:
    () =>
    ({ params }) => {
      return Promise.reject({
        redirect: {
          name: 'enterprise-context/project.entity-with-shortid-only',
          params: {
            ...params,
            tab: 'details',
            detailsTab: params.detailsTab === 'all' ? 'attributes' : params.detailsTab,
          },
        },
      });
    },
};

const dashboardRoute: AppRoute = {
  name: 'project-compatible-dashboard',
  path: `/:organizationName/${PROJECT_URL_PATH_SEGMENT}/e/:shortId/dashboard/:dashboardId`,
  canActivate:
    () =>
    ({ params }) => {
      return Promise.reject({
        redirect: {
          name: 'project.entity-with-shortid-only',
          params: {
            ...params,
            tab: 'details',
            detailsTab: 'dashboard',
          },
        },
      });
    },
};

const enterpriseDashboardRoute: AppRoute = {
  name: 'enterprise-context/project-compatible-dashboard',
  path: `~/o/:organizationName/org/${PROJECT_URL_PATH_SEGMENT}/e/:shortId/dashboard/:dashboardId`,
  canActivate:
    () =>
    ({ params }) => {
      return Promise.reject({
        redirect: {
          name: 'enterprise-context/project.entity-with-shortid-only',
          params: {
            ...params,
            tab: 'details',
            detailsTab: 'dashboard',
          },
        },
      });
    },
};

const experimentsRoute: AppRoute = {
  name: 'project-experiments',
  path: `/:organizationName/${PROJECT_URL_PATH_SEGMENT}/experiments?${FILTERING_QUERY_PARAMS}&${COMPARE_QUERY_PARAMS}&:viewId`,
  canActivate:
    () =>
    ({ params }) => {
      const { split, ...restParams } = params;
      return Promise.reject({
        redirect: {
          name: 'project.runs-tab',
          params: {
            ...restParams,
            tab: getTabFromSplit(split),
          },
        },
      });
    },
};

const enterpriseExperimentsRoute: AppRoute = {
  name: 'enterprise-context/project-experiments',
  path: `~/o/:organizationName/org/${PROJECT_URL_PATH_SEGMENT}/experiments?${FILTERING_QUERY_PARAMS}&${COMPARE_QUERY_PARAMS}&:viewId`,
  canActivate:
    () =>
    ({ params }) => {
      const { split, ...restParams } = params;
      return Promise.reject({
        redirect: {
          name: 'enterprise-context/project.runs-tab',
          params: {
            ...restParams,
            tab: getTabFromSplit(split),
          },
        },
      });
    },
};

export const compatibilityRoutes = [
  experimentsRoute,
  dashboardRoute,
  runDetailsRoute,
  runDetailsNoTabRoute,
  enterpriseExperimentsRoute,
  enterpriseDashboardRoute,
  enterpriseRunDetailsRoute,
  enterpriseRunDetailsNoTabRoute,
];
